module.exports = __webpack_public_path__ + "static/quiz_thumbnail_7-eace94c22933c4eadda3d49b19a90093.jpg";